import { RSAA } from 'redux-api-middleware';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const SEND_FORM_REQUEST = 'farmakom/tags/SEND_FORM_REQUEST';
const SEND_FORM_SUCCESS = 'farmakom/tags/SEND_FORM_SUCCESS';
const SEND_FORM_FAILURE = 'farmakom/tags/SEND_FORM_FAILURE';

const SEND_TICKET_FRESHDESK_REQUEST = 'farmakom/tags/SEND_TICKET_FRESHDESK_REQUEST';
const SEND_TICKET_FRESHDESK_SUCCESS = 'farmakom/tags/SEND_TICKET_FRESHDESK_SUCCESS';
const SEND_TICKET_FRESHDESK_FAILURE = 'farmakom/tags/SEND_TICKET_FRESHDESK_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function sendForm(form) {
    return {
        [RSAA]: {
            ...api.sendForm(form),
            types: [SEND_FORM_REQUEST, SEND_FORM_SUCCESS, SEND_FORM_FAILURE],
        }
    }
}

export function sendTicketFreshdesk(form) {
    return {
        [RSAA]: {
            ...api.sendFreshdeskForm(form),
            types: [SEND_TICKET_FRESHDESK_REQUEST, SEND_TICKET_FRESHDESK_SUCCESS, SEND_TICKET_FRESHDESK_FAILURE],
        }
    }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    sending: false,
    error: '',
    isSent: false
};

export default function contactFormReducer(state = initialState, action) {
    switch (action.type) {
        case SEND_FORM_REQUEST:
        case SEND_TICKET_FRESHDESK_REQUEST:
            return {
                ...state,
                sending: true
            }
        case SEND_FORM_SUCCESS:
        case SEND_TICKET_FRESHDESK_SUCCESS:
            return {
                ...state,
                sending: false,
                error: null,
                isSent: true
            }
        case SEND_FORM_FAILURE:
        case SEND_TICKET_FRESHDESK_FAILURE:
            return {
                ...state,
                sending: false,
                error: action.payload.message
            }
        default:
            return state;
    }
}

// ------------------------------------
// Selectors
// ------------------------------------
